import { Checkbox } from "@heroui/react"
import { PropTypes } from "prop-types"

const BookingConfirmationEmailForm = ({ form, handleUpdateForm }) => (
  <div className='flex flex-col gap-y-4'>
    <Checkbox 
      isSelected={form.booking_confirmations_outstanding_only} 
      onValueChange={(value) => handleUpdateForm("booking_confirmations_outstanding_only", value)} 
      color="secondary"
    >
      Only send booking confirmation emails to users who have not received one yet.
    </Checkbox>
  </div>
)

BookingConfirmationEmailForm.propTypes = {
  form: PropTypes.shape({
    booking_confirmations_outstanding_only: PropTypes.bool.isRequired,
  }).isRequired,
  handleUpdateForm: PropTypes.func.isRequired,
}

export default BookingConfirmationEmailForm